import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-job-color-card',
  templateUrl: './job-color-card.component.html',
  styleUrls: ['./job-color-card.component.scss'],
})
export class JobColorCardComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}

  colors: any = [
    '#D4314E',
    '#E29016',
    '#F3CC00',
    '#9BD100',
    '#489A02',
    '#216552',
    '#057AFF',
    '#004DA5',
    '#2D4C62',
    '#811A74',
    '#957DE5',
    '#FA9FF5',
    '#874740',
    '#C0AE97',
  ];
}
